import { h, normalizeStyle } from 'vue'
import { FontAwesomeIcon as Icon, FontAwesomeLayersText as LayersText } from '@fortawesome/vue-fontawesome'

// vue-fontawesome spreads `attrs.style` into an object, so a Vue 3 string style
// becomes `{ 0: 'c', … }` and Chrome throws on `el.style[0]`, failing the render.
// Remove once vue-fontawesome accepts a string style.
export const styleAsObject = (style) => (typeof style === 'string' ? normalizeStyle([style]) : style)

const withObjectStyle = (component) => {
  const wrapped = (props, { attrs, slots }) => h(component, { ...attrs, style: styleAsObject(attrs.style) }, slots)
  wrapped.inheritAttrs = false
  return wrapped
}

export const FontAwesomeIcon = withObjectStyle(Icon)
export const FontAwesomeLayersText = withObjectStyle(LayersText)
